import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  Button,
  Upload,
  message,
  Modal,
  Progress,
  Input,
} from "antd";
import Title from "antd/lib/typography/Title";
import { UploadOutlined } from "@ant-design/icons";
import { client } from "../../../../../utils/api-client";
import { useAsync } from "../../../../../utils/use-async";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
function Index() {
  const { isLoading, run } = useAsync();
  const { filename } = useParams();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);

  const [filters, setFilters] = useState({
    email: "",
    startDate: "",
    endDate: "",
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [data, setData] = useState([]);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "/",
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
    },

    {
      title: "Hours",
      dataIndex: "hours",
      key: "hours",
      render: (value) =>
        isNaN(value) || value === null ? value : Number(value).toFixed(2),
    },
    {
      title: "details",
      dataIndex: "details",
      key: "details",
    },
  ];

  const fetchRecords = async (page = 1, pageSize = 10) => {
    const { email, startDate, endDate } = filters;
    const query = new URLSearchParams({
      page,
      limit: pageSize,
      ...(email && { email }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
    });
    run(
      client(
        `prod/hours?page=${page}&limit:${pageSize}&email=${email}&startDate=${startDate}&endDate=${endDate}&filename=${filename}`,
        { method: "GET" }
      )
    ).then((res) => {
      message.success(res.message);
      setData(res.data.data);
      setPagination({
        current: page,
        pageSize,
        total: res.data.pagination?.total || 0,
      });
    });
    // console.log(res.data)
  };

  useEffect(() => {
    fetchRecords(pagination.current, pagination.pageSize);
  }, []);

  return (
    <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
      <Card
        style={{
          marginBottom: "24px",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        }}
      >
        <Title level={2} style={{ margin: 0, color: "#1890ff" }}>
          User Target Report
        </Title>
      </Card>

      <Card style={{ marginBottom: "24px" }}>
        <Input
          placeholder="Filter by Email"
          style={{ width: 200, marginRight: 10 }}
          onChange={(e) => setFilters({ ...filters, email: e.target.value })}
        />
        <Input
          type="date"
          style={{ width: 180, marginRight: 10 }}
          onChange={(e) =>
            setFilters({ ...filters, startDate: e.target.value })
          }
        />
        <Input
          type="date"
          style={{ width: 180 }}
          onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
        />
        <Button
          type="primary"
          style={{ marginLeft: 10 }}
          onClick={() => fetchRecords(1, pagination.pageSize)}
        >
          Apply Filters
        </Button>
      </Card>

      <Card>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="_id"
          loading={isLoading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            onChange: (page, pageSize) => fetchRecords(page, pageSize),
            showTotal: (total) => `Total ${total} records`,
          }}
          bordered
          scroll={{ x: "max-content" }}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
        />
      </Card>

      {/* <Modal
        title="Upload File"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Input
          type="file"
          onChange={(e) => setSelectedFile(e.target.files[0])}
        />
        <div style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            onClick={handleUpload}
            disabled={!selectedFile}
          >
            Start Upload
          </Button>
        </div>

        <div style={{ marginTop: "20px" }}>
          {selectedFile && <p>Selected file: {selectedFile.name}</p>}
          <Progress percent={uploadProgress} />
          <div style={{ marginTop: "10px" }}>
            <span>{uploadProgress}%</span>
          </div>
        </div>
      </Modal> */}
    </div>
  );
}

export default Index;
